import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { Avatar, Button, Col, Typography } from "antd";

import { useStores, useTableStores } from "../hooks";
import Table from "../../../shared/components/ui/Table";
import { storesService } from "../../../shared/services";
import { DataStores } from "../../../redux/@types";
import { TableColumns } from "../../../shared/components/ui/Table/types";
import { PATH_S3_BUCKET } from "../../../shared/utils/constants";

const { Title } = Typography;

export const TableStores = () => {
  const { changeStoreForUpdate, showDeleteConfirm } = useTableStores();
  const { setTableProps, updateStatus, isLoading } = useStores();

  const columns: TableColumns<DataStores> = [
    {
      title: "ID",
      width: 3,
      dataIndex: "id",
      key: "id",
      filterType: "text",
    },
    {
      title: "Image",
      width: 7,
      dataIndex: "image_path",
      key: "image_path",
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Avatar size={64} src={`${PATH_S3_BUCKET}/${item.image_path}`} />
          </Col>
        );
      },
    },
    {
      title: "Nombre",
      width: 9,
      dataIndex: "name",
      key: "name",
      filterType: "text",
    },
    {
      title: "Telefono",
      width: 6,
      dataIndex: "phone",
      key: "phone",
    },
    {
      title: "Correo",
      width: 6,
      dataIndex: "email",
      key: "email",
    },
    {
      title: "Horarios",
      width: 6,
      dataIndex: "schedule",
      key: "schedule",
      filterType: "text",
    },
    {
      title: "Direccion",
      width: 6,
      dataIndex: "address",
      key: "address",
      filterType: "text",
    },
    // {
    //   title: "Abierto en",
    //   width: 6,
    //   dataIndex: "open_at",
    //   key: "open_at",
    //   filterType: "text",
    // },
    // {
    //   title: "Fecha de cierre",
    //   width: 6,
    //   dataIndex: "close_at",
    //   key: "close_at",
    //   filterType: "text",
    // },
    
    {
      title: "Acciones",
      key: "operation",
      fixed: "right",
      width: 4,
      render: (_, item) => {
        return (
          <Col
            style={{
              display: "flex",
              width: "100%",
              justifyContent: "space-evenly",
              flexDirection: "row",
            }}
          >
            <Button
              type="primary"
              shape="circle"
              onClick={() => changeStoreForUpdate(item)}
              icon={<EditOutlined />}
              size="large"
            />
            <Button
              type="primary"
              danger
              onClick={() => showDeleteConfirm(item.id, `${item.name}`)}
              shape="circle"
              icon={<DeleteOutlined />}
              size="large"
            />
          </Col>
        );
      },
    },
  ];

  return (
    <Table<DataStores>
      columns={columns}
      fetchQueryProps={{
        $sort: { id: -1 },
      }}
      service={storesService}
      onLoad={setTableProps}
    />
  );
};
